import { PSLINK_URL } from '../constans';
import { apiSlice } from './apiSlice';

const pslinkApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    updateLinkOfStageAndProject: builder.mutation({
      query: (data) => ({
        url: PSLINK_URL,
        method: 'PATCH',
        body: data,
      }),
      keepUnusedDataFor: 5,
    }),
    unlinkStageFromProject: builder.mutation({
      query: (data) => ({
        url: PSLINK_URL,
        method: 'DELETE',
        body: data,
      }),
      keepUnusedDataFor: 5,
    }),
    addImageOfStageOfProject: builder.mutation({
      query: (data) => ({
        url: `${PSLINK_URL}/image`,
        method: 'POST',
        body: data,
      }),
      keepUnusedDataFor: 5,
    }),
  }),
});

export const {
  useUpdateLinkOfStageAndProjectMutation,
  useAddImageOfStageOfProjectMutation,
} = pslinkApiSlice;
